/* eslint-disable import/no-anonymous-default-export */
import './App.css';
import React from "react"
import { TabBar } from "antd-mobile"
import {
  Route,
  Routes,
  useNavigate,
  useLocation,
  MemoryRouter as Router,
} from "react-router-dom"
import {
  PieOutline,
  GlobalOutline,
  UserOutline,
  HeartOutline,
} from "antd-mobile-icons"

import Header from "./common/header"

import Tracker from "./screens/tracker"
import News from "./screens/news"
import RecipeDetails from "./screens/news/details"
import Statistic from "./screens/statistic"
import Dieta from "./screens/dieta"
import Profile from "./screens/profile"
import Ate from "./screens/ate"
import Drank from "./screens/drank"

import styles from "./demo2.less"
import MyDiet from "./screens/myDiet"
import AddNewProduct from "./screens/addNewProduct"

const Bottom = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { pathname } = location

  const setRouteActive = (value) => {
    navigate(value)
  }

  const tabs = [
    {
      key: "/traker",
      title: "Трекер",
      icon: <PieOutline />,
    },
    {
      key: "/news",
      title: "Новости",
      icon: <GlobalOutline />,
    },
    {
      key: "/profile",
      title: "Профиль",
      icon: <UserOutline />,
    },
    {
      key: "/dieta",
      title: "Диета",
      icon: <HeartOutline />,
    },
  ]

  return (
    <TabBar activeKey={pathname} onChange={(value) => setRouteActive(value)}>
      {tabs.map((item) => (
        <TabBar.Item key={item.key} icon={item.icon} title={item.title} />
      ))}
    </TabBar>
  )
}

export default () => {
  return (
    <Router initialEntries={["/traker"]}>
      <div style={{ height: "100vh", display: "flex", flexDirection: "column" }} >
        <div className={styles.top}>
          <Header />
        </div>
        <div
          style={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "auto",
          }}
        >
          <Routes>
            <Route exact path="/traker" element={<Tracker />} />
            <Route exact path="/ate" element={<Ate />} />
            <Route exact path="/drank" element={<Drank />} />
            <Route exact path="/addNewProduct" element={<AddNewProduct />} />
            <Route exact path="/drank" element={<Drank />} />
            <Route exact path="/myDiet" element={<MyDiet />} />
            <Route exact path="/statistic" element={<Statistic />} />
            <Route exact path="/news" element={<News />} />
            <Route exact path="/recipeDetails" element={<RecipeDetails />} />
            <Route exact path="/profile" element={<Profile />} />
            <Route exact path="/dieta" element={<Dieta />} />
          </Routes>
        </div>
        <div className={styles.bottom}>
          <Bottom />
        </div>
      </div>
    </Router>
  )
}
